module.exports = __webpack_public_path__ + "static/product-page-2-b6101d286b48fda99ae6987ca567f42e.png";